import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://john316painting.com";

export default function SeoHelmet({
  title = "John 3:16 Painting | Residential & Commercial Painting in Oklahoma",
  description = "Professional residential and commercial painting services in Oklahoma City and surrounding areas. Exterior painting, interior painting, cabinets, woodwork, drywall repairs, staining and power washing.",
  keywords = "painting contractor Oklahoma, house painting Oklahoma City, exterior painting, interior painting, cabinet painting, drywall repair, power washing",
  image = "/assets/img/principal.webp",
  url = SITE_URL,
}) {
  const fullImage = image.startsWith("http") ? image : `${SITE_URL}${image}`;

  return (
    <Helmet>
      <html lang="en" />

      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="John 3:16 Painting" />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="John 3:16 Painting" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
    </Helmet>
  );
}
